<template>
  <div class="trims-accessories-result">
    <div v-for="(item, index) in trimsAndAccessories" :key="index" class="result">
      <!-- Your result item content here -->
      <div>
        <img :src="item.trimColors[0].imagesInfo[0].url" alt="Main Image" />

        <!-- Color Squares - Swiper -->
        <div class="wf-swiper-thumbnails" :class="'wf-product-thumbnails-size-' + 'sizehere'">
          <!-- Add your Swiper component here -->
          <!-- ... -->
        </div>

        <!-- Text -->
        <div class="description">
          <div>{{ `${item.sellingStyleName} ${item.sellingStyleNumber}` }}</div>
          <div>{{ `${item.trimColors.length} ${item.trimColors.length > 1 ? 'colors' : 'color'}` }}</div>
          <div><a @click="learnMore(item)">Learn More</a></div>
          <div> For more samples or more information <a @click="contactManager(item)"> contact your Patcraft account
              manager</a></div>
        </div>
      </div>
    </div>
    <p v-if="trimsAndAccessories.length === 0 && !isFetching">
      {{ $resourceString["common.noResults"] }}
    </p>

    <button class="wf-swiper-nav-button wf-swiper-nav-button-next btn btn-full" type="button">
      <span class="
              png-icon
              png-icon-icons-glyph--ko-chevron-right
              arrow-right
              png-size
              mt-1
            " aria-label="Next color" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    trimsAndAccessories: {
      type: Array,
      required: true,
    },
    isFetching: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    learnMore(item) {
      // Handle Learn More action
      console.log(`Learn More clicked for ${item.sellingStyleName} ${item.sellingStyleNumber}`);
    },
    contactManager(item) {
      // Handle Contact Manager action
      console.log(`Contact Manager clicked for ${item.sellingStyleName} ${item.sellingStyleNumber}`);
    },
  },
};
</script>

<style scoped>
/* Add your styling here */
/* Ensure the styling aligns with the overall design of your application */
.result {
  border: 1px solid #ddd;
  /* Add other styling properties as needed */
}
</style>
